/* eslint-disable react-hooks/exhaustive-deps, react/jsx-props-no-spreading */
import React from 'react';
import { Grid } from '@mui/material';
import { Importer, ImporterField } from '../../../modules/csvImporter';
import 'react-csv-importer/dist/index.css';
import { CustomersAutoTreatValidationsContext } from '../contexts/CustomersAutoTreatValidationsContext';
import { CustomersAutoTreatImportContext } from '../contexts/CustomersAutoTreatImportContext';
import CustomerImportStepper from './CustomerImportStepper';
import { sanitizeInputs } from '../../../modules/shared/utils/sanitizeInputs';

interface CustomerAutoTreatcsvImportProps {
  apiPartner?: string;
  machineSerialNumber: any;
}

const CustomerAutoTreatcsvImport: React.FunctionComponent<CustomerAutoTreatcsvImportProps> = (props) => {
  const { apiPartner, machineSerialNumber } = props;

  const [activeStep, setActiveStep] = React.useState(0);

  const [nextButtonDisabled, setNextButtonDisabled] = React.useState(true);
  const [triggerUnAcceptFile, setTriggerUnAcceptFile] = React.useState<number>(0);

  const { validatecsvImportRow } = React.useContext(CustomersAutoTreatValidationsContext);
  const { setPassedRecords, passedRecords, setFailedRecords, sendCustomersBulkAutoTreat, failedRecords } =
    React.useContext(CustomersAutoTreatImportContext);

  const handleEnableNext = (value) => {
    setNextButtonDisabled(value);
  };

  const handleSubmit = () => {
    sendCustomersBulkAutoTreat(machineSerialNumber, passedRecords, apiPartner);
  };

  const triggerNextStep = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleUnAcceptFile = () => {
    setTriggerUnAcceptFile((triggerUnAcceptFile) => triggerUnAcceptFile + 1);
  };

  const triggerBackStep = () => {
    setPassedRecords([]);
    setFailedRecords([]);
    if (activeStep !== 0) {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
    if (activeStep === 1) {
      handleUnAcceptFile();
    }
  };

  const handleValidateRows = (rows) => {
    const tempPassdRecords = [];
    const tempFailedRecords = [];
    const compoundIdCounts = {};

    const tempSanitizedRows = sanitizeInputs(rows);

    tempSanitizedRows.forEach((row) => {
      if (row.active === null || row.active === '') {
        row.active = '1';
      }
    });
    tempSanitizedRows.forEach((row) => {
      const compoundId =
        (row.partner_record_id_1 || '') + (row.partner_record_id_2 || '') + (row.partner_record_id_3 || '');
      compoundIdCounts[compoundId] = (compoundIdCounts[compoundId] || 0) + 1;
    });
    tempSanitizedRows.forEach((row, index) => {
      const rowValidation = validatecsvImportRow(row);
      const validValues = ['0', '1', 'true', 'false'];

      if (!validValues.includes(row.active.toLowerCase())) {
        rowValidation.error = true;
        rowValidation.errorMessage = '"Active" must be "0", "1", "true", or "false".';
      }

      if (apiPartner) {
        const compoundId =
          (row.partner_record_id_1 || '') + (row.partner_record_id_2 || '') + (row.partner_record_id_3 || '');

        if (row.partner_record_id_1 === null || row.partner_record_id_1 === '') {
          rowValidation.error = true;
          rowValidation.errorMessage = 'partner_record_id_1 cannot be blank';
        } else if (compoundIdCounts[compoundId] > 1) {
          rowValidation.error = true;
          rowValidation.errorMessage = 'Duplicate partner id found';
        }
      }

      if (rowValidation.error) {
        tempFailedRecords.push({ ...row, errorMessage: rowValidation.errorMessage });
      } else {
        tempPassdRecords.push(row);
      }
    });
    setPassedRecords((prevPassedRecords) => [...prevPassedRecords, ...tempPassdRecords]);
    setFailedRecords((prevFailedRecords) => [...prevFailedRecords, ...tempFailedRecords]);
  };

  return (
    <>
      <Grid justifyContent="space-between" container spacing={1}>
        <Grid item marginTop={1} xs={12}>
          <Importer
            activeStep={activeStep}
            enableNext={handleEnableNext}
            dataHandler={async (rows, { startIndex }) => {
              handleValidateRows(rows);
            }}
            passedRecords={passedRecords}
            failedRecords={failedRecords}
            defaultNoHeader={false} // optional, keeps "data has headers" checkbox off by default
            stepperComponent={
              <CustomerImportStepper
                triggerNextStepProp={triggerNextStep}
                triggerBackStepProp={triggerBackStep}
                activeStep={activeStep}
                nextDisabled={nextButtonDisabled}
              />
            }
            unAcceptFile={triggerUnAcceptFile}
            sendToMachine={handleSubmit}
            apiPartner={apiPartner}
            columnsTitle="Autotreat Customer Fields"
          >
            <ImporterField name="operation" label="operation" />
            <ImporterField name="first_name" label="first_name" optional />
            <ImporterField name="last_name" label="last_name" optional />
            <ImporterField name="comment" label="comment" optional />
            <ImporterField name="customer_desc" label="customer_desc" optional />
            <ImporterField name="address1" label="address1" optional />
            <ImporterField name="address2" label="address2" optional />
            <ImporterField name="city" label="city" optional />
            <ImporterField name="state" label="state" optional />
            <ImporterField name="country" label="country" optional />
            <ImporterField name="zip_code" label="zip_code" optional />
            <ImporterField name="mobile_phone" label="mobile_phone" optional />
            <ImporterField name="business_phone" label="business_phone" optional />
            <ImporterField name="email" label="email" optional />
            <ImporterField name="auto_email" label="auto_email" optional description="Default: False" />
            <ImporterField name="active" label="active" optional description="Default: True" />
            {apiPartner && (
              <>
                {/* <ImporterField name="api_partner" label="api_partner" optional /> */}
                <ImporterField name="partner_record_id_1" label="partner_record_id_1" />
                <ImporterField name="partner_record_id_2" label="partner_record_id_2" optional />
                <ImporterField name="partner_record_id_3" label="partner_record_id_3" optional />
              </>
            )}
          </Importer>
        </Grid>
      </Grid>
    </>
  );
};

export default CustomerAutoTreatcsvImport;
